import request from "@/utils/request";

/**
 *
 * @param data 分页参数对象 --page页码 rows 每页条数   liveType--- 1店铺，2景区，3农业，4道路，5餐饮，6幼儿园
 */
export const liveListApi = (data) => request.get({
  url: 'home/getLiveList',
  data
})
